import { useContext } from 'react';
import SideBarContentContext from '../SideBarContentContext';

export default function useSideBarContent() {
  return useContext(SideBarContentContext);
}
